var map = {
	"./BoolBnb.png": 7295,
	"./BoolFlix.png": 4247,
	"./Booleando.png": 3114,
	"./CargoProject.png": 8027,
	"./DcComics.png": 1477,
	"./DiscorsStatic.png": 1666,
	"./Dropbox.png": 9653,
	"./Playstation.png": 641,
	"./SpotifyStatic.png": 1196,
	"./VueBoolZapp.png": 8739
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7388;